import { de, hr } from "date-fns/locale";

/**
 * @description Constant that defines default language
 */
export const DEFAULT_LANGUAGE = "hr";
export const LOCALES = ["hr", "de"] as const;

export type Locale = (typeof LOCALES)[number];

export const MappedLocales = new Map([
  ["hr", hr],
  ["de", de],
]);
